// Combined jQuery 3.5.1 + Bootstrap 5 bundle. Replaces the vendored
// jquery-3.3.1.min.js + popper.min.js + bootstrap.min.js scripts with one IIFE
// that must load before any other jQuery-dependent script.
//
// - jQuery is exposed as window.$/jQuery (for the vendored jQuery plugins that
//   load afterwards).
// - Bootstrap 5 is exposed as window.bootstrap (matching the global the old
//   bootstrap.min.js UMD set), so page code using the BS5 API
//   (`new bootstrap.Modal`, `bootstrap.Offcanvas`, …) keeps working. Importing
//   it also registers Bootstrap's data-API listeners (data-bs-toggle dropdowns,
//   collapse, …) and pulls in @popperjs/core for positioning.
import "./_jquery-setup.js";
import * as bootstrap from "bootstrap";

window.bootstrap = bootstrap;
